import { IonIcon } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';

import styles from './MessageImage.module.scss';

interface Props {
  src: string;
  locked: boolean;
}

export const MessageImage: React.FC<Props> = ({ src, locked }) => {
  return (
    <div className={styles['image-wrapper']}>
      <img src={src} alt="image message" />
      {locked && <IonIcon icon={lockClosed} />}
    </div>
  );
};
